import { Component, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { AppService } from '../../../app.service';
import { Title } from '@angular/platform-browser';
import { LoadingService } from '../../services/loading.service';
import { TranslateService } from '../../../translate';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { Location } from '@angular/common';
import {
    CurrentSelection, SelectionLists,
    Customer, JobSite, Equipment
    ,
} from '../../../entities';
//HrM
//import { MatSnackBar } from '@angular/material';
import { SetupUndercarriageService } from '../../../modules/setup-undercarriage/setup-undercarriage.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'select-equipment',
    templateUrl: './select-equipment.component.html',
    styleUrls: ['./select-equipment.component.scss'],
    animations: [
        trigger(
            'fadeInOut', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('500ms', style({ opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ opacity: 0 }),
                    animate('0ms', style({ opacity: 0 }))
                ])
            ]
        )]
})
export class SelectEquipment {
    translateSubscription: Subscription;
    userLanguage: string = "english";
    _loading: number = 0;
    _dropDownLists: SelectionLists = new SelectionLists();
    _dropDownListsFiltered: SelectionLists = new SelectionLists();
    _currentSelection: CurrentSelection = new CurrentSelection();
    _returnRoute: string = '';
    _selectedEquipment: Equipment = new Equipment();
    constructor(private _setupService: SetupUndercarriageService, private _appService: AppService, private titleService: Title,
        private _router: Router, private ref: ChangeDetectorRef,
        private _translate: TranslateService,
        private _formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        private location: Location,
        private _notification: NotificationsService, private _route: ActivatedRoute,
        private _loadingService: LoadingService) {
    }
    ngOnInit() {
        this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
        this._route.params.subscribe((params: Params) => {
            if (params['ReturnRoute']) this._returnRoute = params['ReturnRoute'];

        }, error => console.error(error), () => { });
        this._loading++;
        this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this._dropDownLists.customerList = result; this._dropDownListsFiltered.customerList = result;  }, error => { console.error(error); }, () => { this._loading--; });
        this._loading++;
        this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this._dropDownLists.jobSiteList = result; }, error => { console.error(error); }, () => { this._loading--; });
        this._loading++;
        this._appService.getEquipmentListForSelection(1, 10000).subscribe(result => { this._dropDownLists.equipmentList = result;  }, error => { console.error(error); }, () => { this._loading--; });
    }
    ngOnDestroy() {
        this.translateSubscription.unsubscribe();
    }

    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
    }

    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }

    customerChanged(event: any): void {
        let customer: Customer = event.value;
        if (!customer) return;
        this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId == customer.Id);
        this._currentSelection.jobSite = new JobSite();
        this._dropDownListsFiltered.equipmentList = [];
        this._currentSelection.equipment = new Equipment();
    }

    jobsiteChanged(event: any): void {
        let jobsite: JobSite = event.value;
        if (!jobsite) return;
        this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(m => m.JobSiteId == jobsite.Id);
        this._currentSelection.equipment = new Equipment();
    }

    equipmentChanged(event: any): void {
        console.log(event);
        this._selectedEquipment.Id = event.value.Id;
        this._selectedEquipment.JobSiteId = event.value.JobSiteId;
        this._selectedEquipment.Serial = event.value.Serial;
        this._selectedEquipment.Unit = event.value.Unit;
    }
    submit() {
        if (this._selectedEquipment.Id != 0)
            this._router.navigateByUrl(this._returnRoute + '/equipment/' + this._selectedEquipment.Id);
        else
            this._notification.warn('Equipment is not selected!', 'Please select an equipment');
    }
}
